module.exports = __webpack_public_path__ + "img/SE2021002684.0455027e.svg";